import { Box, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);
interface XDateFieldProps {
  value?: string | Date | number;
  emptyBox?: boolean;
  fullDate?: boolean;
  relative?: boolean;
  sx?: Object;
}

const XDateField = ({ value, emptyBox, fullDate, relative, sx }: XDateFieldProps) => {
  if (!value) {
    if (emptyBox) {
      return <Box sx={sx} />;
    }
    return null;
  }

  const date = dayjs(value);
  const fullTime = date.format('YYYY/MM/DD HH:mm:ss');
  const shortTime = date.format('YYYY/MM/DD');
  const relativeTime = date.fromNow();

  let displayText = shortTime;
  if (fullDate) {
    displayText = fullTime;
  } else if (relative) {
    displayText = relativeTime;
  }

  return (
    <Box sx={sx}>
      <Tooltip title={fullTime}>
        <Typography variant="body2" noWrap>
          {displayText}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default XDateField;
